/*
 * Счётчик. Из макета: «3» на пункте «Журнал», «3» на колокольчике,
 * «14» на вкладке «Визиты», «48» на чипе «Все».
 */

.counter {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 17px;
  padding: 0 6px;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  line-height: 1.6;
  border-radius: var(--radius-pill);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

/* Требует внимания: непрочитанные уведомления, записи, ждущие подтверждения. */
.attention {
  background: var(--danger);
  color: var(--text-on-danger);
}

/* Просто количество: сколько визитов на вкладке. Не зовёт, а сообщает. */
.quiet {
  background: var(--bg-sunken);
  color: var(--text-secondary);
}

/* На бордовой навигации: там и «тихий» фон рабочей области был бы пятном. */
.onNav {
  background: var(--danger);
  color: var(--text-on-danger);
}

/* Счётчик поверх значка (колокольчик в шапке). Позиционируется относительно кнопки,
   поэтому у неё обязан быть position: relative — он есть у .button. */
.corner {
  position: absolute;
  top: -6px;
  right: -6px;
  z-index: var(--z-header-corner);
}
